export const CHILD_PIN_MIN_LENGTH = 4;
export const CHILD_PIN_MAX_LENGTH = 6;

export function isValidChildPin(pin: string): boolean {
  return new RegExp(`^\\d{${CHILD_PIN_MIN_LENGTH},${CHILD_PIN_MAX_LENGTH}}$`).test(pin);
}

export function pinValidationMessage(pin: string): string | null {
  if (!pin) return '자녀 PIN을 입력해 주세요.';
  if (!isValidChildPin(pin)) return 'PIN은 숫자 4~6자리로 설정해 주세요.';
  if (/^(\d)\1+$/.test(pin)) return '같은 숫자만 반복한 PIN은 사용할 수 없습니다.';
  if (['1234', '4321', '0123', '9876', '0000'].includes(pin)) return '쉽게 추측할 수 있는 PIN은 사용할 수 없습니다.';
  return null;
}
